import { useEffect } from 'react';

import { Flex } from '@grupoboticario/flora-react';
import { EnvelopeClosedIcon } from '@grupoboticario/flora-react-icons';
import slugify from 'slugify';

import { ResponsiveFloraTypography, Skeleton } from 'components';
import { getMessageStatusValue } from 'components/Drawers/CadastralChange/helpers';
import config from 'config';
import { useResellerRegistration, useTracking } from 'hooks';
import { useGlobalContext } from 'store';

import { EditButton, MessageChanged } from './components';
import ProfileComponentsStyles from '../../../Profile.components.styles';

type EmailParamsType = {
  isLoading: boolean;
  email: string;
};

export const Email = ({ isLoading, email }: EmailParamsType) => {
  const { user } = useGlobalContext();
  const { sendDataToGTM } = useTracking();
  const { data: registration, isSuccess } = useResellerRegistration();

  useEffect(() => {
    const statusEmail = registration?.email?.status ?? '';

    if (isSuccess) {
      sendDataToGTM({
        event: 'page_view',
        page_location: `${config.app.url}perfil`,
        userId: user.resellerId,
        ...(statusEmail !== 'none' && {
          cd_status_alteracao: slugify(`email:${getMessageStatusValue(statusEmail)}`, {
            lower: true,
          }),
        }),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  if (!email) {
    return null;
  }

  return (
    <>
      <ProfileComponentsStyles.InfoWrapper gap='$16'>
        <Flex direction='column' gap='$2'>
          <ProfileComponentsStyles.SubText fontSize='bodySmallShort'>
            <Flex align='center' gap='$1'>
              <EnvelopeClosedIcon size={16} /> E-mail
            </Flex>
          </ProfileComponentsStyles.SubText>

          {isLoading ? (
            <Skeleton data-testid='skeleton-detail' height='$5' width='50%' />
          ) : (
            <ResponsiveFloraTypography>{email.toLowerCase()}</ResponsiveFloraTypography>
          )}
        </Flex>
        <EditButton />
      </ProfileComponentsStyles.InfoWrapper>

      <MessageChanged />
    </>
  );
};
